<template>
  <Multiselect v-model="valueModel"
               label="name"
               trackBy="id"
               valueByPath="id"
               :options="taskTypes"
               :max="max"
  ></Multiselect>
</template>

<script>
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'

export default {
    name: 'UITaskTypeSelect',
    components: {
        Multiselect,
    },
    props: {
        value: {
            required: true,
            type: Array,
            default: _ => [],
        },
        max: {
            required: false,
            type: Number,
            default: _ => -1,
        },
    },
    computed: {
        taskTypes() {
            return this.$store.getters.taskTypes
        },
        valueModel: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
    },
}
</script>
